module.exports = __webpack_public_path__ + "media/images/logo-sm-c9907f0e.png";